import React, { FC } from "react";
import { Typography, Box, CircularProgress } from "@mui/material";

interface IProps {
  copy?: string;
}

export const Loading: FC<IProps> = ({ copy }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        minHeight: 300,
      }}
    >
      <CircularProgress
        sx={{
          color: "primary.main",
          my: 2,
        }}
      />
      <Box textAlign="center">
        <Typography variant="body1">{copy || "Loading"}...</Typography>
      </Box>
    </Box>
  );
};
